module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Grayzel_30_side.090ce597.png";